import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TextToSlugPipe } from '../../_pipe/textToSlug.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalizeRouterService } from 'localize-router';
import { StorageService } from '../../_services/storage.service';
import { PreferitiService } from '../../_services/preferiti.service';
import { Subscription } from 'rxjs';
import { HeaderService } from '../../_services/header.service';
import { AuthService } from '../../_services/auth.sevice';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styles: []
})
export class CardComponent implements OnInit, OnDestroy {

  constructor(
    private preferiti: PreferitiService,
    private localize: LocalizeRouterService,
    private auth: AuthService,
    private header: HeaderService,
    ) { }

  @Input() scheda;
  @Input() showAcquista = true;
  @Output() aggiungiAlCarrelloClicked = new EventEmitter<void>();

  pathFile = '';  // mettere il percorso dell'immagine placholder in caso di assenza di foto

  bolliniEvidenziati = [];
  bwCard = false;
  urlDettaglio: string;
  fotoPrincipale;
  isPreferito = false;

  subs: Subscription[] = [];

  isLoggedIn = this.auth.isLogged;

  get acquistaDisabled() {
    return (
      this.scheda &&
      this.scheda.infoCommerciali &&
      this.scheda.infoCommerciali.FLAG_NON_DISPONIBILE &&
      this.scheda.infoCommerciali.FLAG_NON_DISPONIBILE.valore === 'true');
  }

  ngOnInit() {
    if (this.scheda) {
      this.bwCard = this.scheda.bollini ? this.scheda.bollini.find(bollino => bollino.nome === 'BWCard') : null;
      const slugScheda = this.scheda.seo.slug ? this.scheda.seo.slug : this.scheda.seo[this.localize.parser.currentLang.toUpperCase()].slug;
      this.urlDettaglio = this.scheda.categorie[0] && this.scheda.sottocategorie[0] ?  '/' + this.scheda.categorie[0].seo.slug + '/' + this.scheda.sottocategorie[0].seo.slug + '/' + slugScheda : undefined;
      if (this.scheda.staffaTelaio || this.scheda.staffaPortiera) {
        this.urlDettaglio += `?staffaTelaio=${this.scheda.staffaTelaio ? this.scheda.staffaTelaio.id : null}&staffaPortiera=${this.scheda.staffaPortiera ? this.scheda.staffaPortiera.id : null}&idPercorso=${this.scheda.idPercorso}`;
      }
      this.fotoPrincipale = this.scheda.foto instanceof Array ?
        this.scheda.foto.find(foto => foto.principale) || this.scheda.foto[0] :
        this.scheda.foto;

      if (this.isLoggedIn) {
        this.preferiti.getPreferiti().subscribe(preferiti => this.isPreferito = preferiti.find(p => p.idScheda === (this.scheda.id || this.scheda.idScheda)));
        this.subs.push(
          this.header.aggiornaPreferiti.subscribe(() => {
            this.preferiti.getPreferiti().subscribe(preferiti => this.isPreferito = preferiti.find(p => p.idScheda === (this.scheda.id || this.scheda.idScheda)));
          })
        );
      }
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  aggiungiAlCarrello() {
    this.aggiungiAlCarrelloClicked.emit();
  }

  aggiungiAiPreferiti() {
    this.isPreferito ?
      this.preferiti.deletePreferito(this.scheda).subscribe() :
      this.preferiti.salvaPreferito(this.scheda).subscribe();
  }

}
